import { CriticalIcon, theme } from '@veeqo/ui';
import { useTranslation } from 'context/TranslationContext';
import { getAlertFromKey } from '../../utils/getAlertFromKey';
import { ContentStyle, ErrorType } from '../../content';
import { AlertEl } from './styled';

export const Alert = ({
  contentStyle,
  errorKey,
  jobId,
}: {
  contentStyle: ContentStyle;
  errorKey?: ErrorType;
  jobId?: string;
}) => {
  const { titleId, message, rightActions } = getAlertFromKey({ contentStyle, errorKey, jobId });
  const { t } = useTranslation();
  return (
    <AlertEl
      contentStyle={contentStyle}
      variant="error"
      title={t(titleId)}
      messageSlot={message}
      rightActionsSlot={rightActions}
      iconSlot={
        <CriticalIcon style={{ color: theme.colors.secondary.red.dark }} width="24" height="24" />
      }
    />
  );
};
